import { get } from 'lodash';
import { StudentDetails } from '../types';

export function transformSearchStudentFeeEntryData(
  data: any[]
): StudentDetails[] {
  return data.map((record) => {
    const transformedRecord: Partial<StudentDetails> = {
      id: get(record, 'student.id', ''),
      enrollmentNo: get(record, 'student.enrollmentNo', ''),
      studentName: get(record, 'student.name', ''),
      class: `${get(record, 'student.grade', '')} ${get(
        record,
        'student.division',
        ''
      )}`.trim(),
      fatherName: get(record, 'parents.father.name', ''),
      motherName: get(record, 'parents.mother.name', ''),
      studentEmail: get(record, 'student.email', ''),
      status: get(record, 'student.status', ''),
      studentType: get(record, 'student.studentType', ''),
      studentProfile: get(record, 'student.profile', '')
    };

    return transformedRecord as StudentDetails;
  });
}
